import type { ProviderEvent } from "./provider-event";

type EventCallback<T> = (payload: T) => ProviderEvent;

export class EventEmitter<
  T extends { name: string; payload: Record<string, unknown> },
> {
  private listeners: {
    [K in T["name"]]?: EventCallback<Extract<T, { name: K }>["payload"]>[];
  } = {};

  on<K extends T["name"]>(
    eventName: K,
    callback: EventCallback<Extract<T, { name: K }>["payload"]>,
  ): void {
    if (!this.listeners[eventName]) {
      this.listeners[eventName] = [];
    }
    this.listeners[eventName]!.push(callback);
  }

  emit<K extends T["name"]>(event: Extract<T, { name: K }>): void {
    const listeners = this.listeners[event.name];
    if (listeners) {
      listeners.forEach((callback) => callback(event.payload));
    }
  }
}
